export const Events = {
  LABEL_FIRST_INPUT_DELAY: 'first-input-delay',
  LABEL_TIME_TO_FIRST_BYTE: 'time-to-first-byte',
  LABEL_TIME_TO_INTERACTIVE: 'time-to-interactive',
  LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT: 'first-contentful-paint',
  LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT: 'largest-contentful-paint',
  LABEL_CUMULATIVE_LAYOUT_SHIFT: 'cumulative-layout-shift',
  LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT: 'first-meaningful-paint',
  LABEL_RESOURCE_DOWNLOAD_TIME_SUM: 'resource-download-time-sum',
  LABEL_CAAS_SPI_METHOD_EXECUTION: 'caas-spi-execution',
  LABEL_ALGOLIA_SEARCH_TIMING: 'algolia-search',
  LABEL_COMPONENT_ERROR_BOUNDARY: 'component-error-boundary',
  LABEL_GENERIC_TASK: 'generic-task',
  LABEL_PAGE_VIEW_TASK: 'page-view-task',
  LABEL_ROUTE_CHANGE_START: 'route-change-start',
  LABEL_TRACE_UFO_PAGE_LOAD: 'trace-ufo-page-load',
  LABEL_UFO_INTERACTION_ERROR: 'set-ufo-interaction-error',
  LABEL_TRACE_UFO_PRESS: 'trace-ufo-page-press'
};
export const TelemetryErrorType = {
  Ignore: 'IGNORE',
  Error: 'ERROR',
  Warning: 'WARNING'
};

/** @see https://developer.atlassian.com/platform/metal/introduction/metric-descriptions/#component-boundary-errors */